import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { api } from '../api';
import clipoidLogo from '../../assets/clipoid_logo.png';
import { CardSpotlight } from '../components/aceternity/CardSpotlight';

function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError('');
    setMessage('');
    setIsSubmitting(true);

    try {
      const response = await api.post('/auth/forgot-password', { email });
      if (response.data.success) {
        setMessage(response.data.message);
      } else {
        setError(response.data.message || 'An error occurred.');
      }
    } catch (err: any) {
        if (err.response && err.response.data && err.response.data.message) {
            setError(err.response.data.message);
        } else {
            setError('An unexpected error occurred. Please try again.');
        }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen h-screen w-full flex items-center justify-center bg-black antialiased">
      <CardSpotlight className="group/spotlight w-full max-w-md">
        <div className="relative z-20">
          <div className="flex justify-center mb-8">
            <img src={clipoidLogo} alt="Clipoid Logo" className="h-14" />
          </div>
          <h1 className="text-3xl font-bold text-foreground mb-6 text-center">
            Forgot Password
          </h1>
          {message && (
            <div className="bg-green-500/10 border border-green-500 text-green-400 px-4 py-3 rounded-md w-full mb-4 text-sm" role="alert">
              {message}
            </div>
          )}
          {error && (
            <div className="bg-red-500/10 border border-red-500 text-red-400 px-4 py-3 rounded-md w-full mb-4 text-sm" role="alert">
              {error}
            </div>
          )}
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="email" className="sr-only">Email Address</label>
              <input
                type="email"
                id="email"
                placeholder="Enter your email address"
                className="block w-full px-4 py-3 bg-input border border-border rounded-lg text-foreground placeholder-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition duration-150 ease-in-out"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={isSubmitting}
                required
              />
            </div>
            <button
              type="submit"
              className="w-full bg-primary text-primary-foreground hover:bg-primary/90 font-semibold py-3 px-4 rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-background focus:ring-primary disabled:opacity-60 disabled:cursor-not-allowed transition duration-300 ease-in-out"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Sending...' : 'Send Reset Link'}
            </button>
            <div className="text-center mt-8 text-sm">
              <RouterLink
                to="/login"
                className="px-4 py-2 rounded-md text-primary hover:bg-primary/10 hover:text-primary/80 transition duration-150 ease-in-out"
              >
                Back to Login
              </RouterLink>
            </div>
          </form>
        </div>
      </CardSpotlight>
    </div>
  );
}

export default ForgotPasswordPage;